import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(1),
    minWidth: 120,
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const CommonSelect = ({
  options, label, helpText, handleChange, selectedValue,
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(selectedValue ?? '');

  const handleLocalChange = (event) => {
    setValue(event.target.value);
    handleChange(event.target.value)
  };

  if (options === undefined) return null;
  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}>
        {label !== undefined ? <InputLabel>{label}</InputLabel> : null}
        <Select value={value} onChange={handleLocalChange} autoWidth label={label}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.text} value={option.value}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
        {helpText !== undefined ? (
          <FormHelperText>{helpText}</FormHelperText>
        ) : null}
      </FormControl>
    </div>
  );
};

export default CommonSelect;
